import styled, { css } from "styled-components";
import {
  BRAND,
  ERROR_LIGHT,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_PRIMARY
} from "@streeteasy/design-system/colors";
import { darken } from "polished";

export const ListItem = styled.li`
  margin: 0 -15px;
  position: relative;
`;

export const List = styled.ul`
  border-bottom: 1px solid ${GRAY_LIGHT};
  margin: 0 20px;
  padding: 7px 0 11px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  ${ListItem}:hover {
    text-decoration: underline;
  }
`;

export const ListItemLink = styled.a`
  color: ${TEXT_PRIMARY};
  display: block;
  line-height: 1.3;
  padding: 10px 15px;
  position: relative;
  text-align: left;

  &:hover {
    background: ${GRAY_LIGHTEST};
    text-decoration: underline;
  }

  &:active {
    color: ${darken(0.16, BRAND)};
  }

  ${({ isAttention }) =>
    isAttention
      ? css`
          &::before {
            background-color: ${ERROR_LIGHT};
            border-radius: 53%;
            content: "";
            display: block;
            height: 8px;
            margin-top: -4px;
            position: absolute;
            right: 10px;
            top: 50%;
            width: 8px;
          }
        `
      : ""}
`;
